import { render, staticRenderFns } from "./datajob-record-list.vue?vue&type=template&id=712b417e&scoped=true&"
import script from "./datajob-record-list.vue?vue&type=script&lang=ts&"
export * from "./datajob-record-list.vue?vue&type=script&lang=ts&"
import style0 from "./datajob-record-list.vue?vue&type=style&index=0&id=712b417e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b417e",
  null
  
)

export default component.exports